// removed by extract-text-webpack-plugin
module.exports = {"Logo":"logo__Logo__2cXwS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/logo.css
// module id = 115
// module chunks = 8